










































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Modal from "@/components/Modal/Modal.vue";
import Card from "@/components/Card/Card.vue";
import LevelItem from "@/components/Level/LevelItem.vue";
import Level from "@/components/Level/Level.vue";
import {Action, Getter, Mutation} from "vuex-class";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import Form from "@/components/Form/Form.vue";
import Input from "@/components/Form/elements/Input.vue";

import AppConfig from "@/config/AppConfig";
import AuthService from "@/service/AuthService";
import SubmitButton from "@/components/Form/elements/SubmitButton.vue";
import TextArea from "@/components/Form/elements/TextArea.vue";
import SelfUpdatingTimeDiff from "@/components/SelfUpdatingTimeDiff/SelfUpdatingTimeDiff.vue";
import format from "vue-i18n/src/format";
import RadioButtons from "@/components/Form/elements/RadioButtons.vue";


const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';

const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';

@Component({
  components: {RadioButtons, SelfUpdatingTimeDiff, TextArea, SubmitButton, Input, Form, Card, Modal}
})
export default class StopTimeTrackingRecordModal extends Vue {
  public name: string = "StopTimeTrackingRecordModal";

  @Prop({required: true, default: false})
  public active!: boolean;

  @Action('loadUsersRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) loadUsersRunningRecord: any;

  @Action('load', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) loadDataList: any;

  @Action('stopRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) stopRunningRecord: any;
  @Action('updateListItem', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) updateListItem: any;

  @Getter('getRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) runningTimeTrackingRecord: any;

  @Mutation('SET_RUNNING_RECORD', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) setRunningRecord: any;

  @Watch('runningTimeTrackingRecord', {immediate: true, deep: true})
  private onRunningTimeTrackingRecordChange(newVal: any, oldVal: any) {

    if (this.runningTimeTrackingRecord) {
      this.text = this.runningTimeTrackingRecord.text;
      this.ticket_url = this.runningTimeTrackingRecord.ticket_url;
    }

  }

  private start: string = '';
  private stop: string = '';
  private text: string = '';
  private ticket_url: string = '';

  private authService: any = new AuthService();
  private currentUserId: number = this.authService.getUserId();
  private finishTask: number = 0;


  private activeChanged(e: any) {

    if (e === true) {
      this.time();
    }
    this.$emit('active-changed', e);
  }

  private get appConfig(): any {

    return AppConfig;

  }

  private get getRunningTimeTrackingRecord(): ITimeTrackingRecord | null {

    if (this.runningTimeTrackingRecord) {
      return {
        id: this.runningTimeTrackingRecord.id ?? 0,
        text: this.runningTimeTrackingRecord.text ?? '',
        ticket_url: this.ticket_url ?? '',
        budget: this.runningTimeTrackingRecord.budget ?? '',
        start: this.runningTimeTrackingRecord.start ?? '',
        stop: this.runningTimeTrackingRecord.stop ?? '',
        task_id: this.runningTimeTrackingRecord.task_id ?? 0,
        task: this.runningTimeTrackingRecord.task,
        client_id: this.runningTimeTrackingRecord.client_id ?? 0,
        client: this.runningTimeTrackingRecord.client,
        brand_id: this.runningTimeTrackingRecord.brand_id ?? 0,
        brand: this.runningTimeTrackingRecord.brand,
        project_id: this.runningTimeTrackingRecord.project_id ?? 0,
        project: this.runningTimeTrackingRecord.project,
        type: this.runningTimeTrackingRecord.type,
        type_id: this.runningTimeTrackingRecord.type_id ?? 0,
        user_id: this.runningTimeTrackingRecord.user_id ?? 0,
        created_at: this.runningTimeTrackingRecord.created_at ?? '',
        updated_at: this.runningTimeTrackingRecord.updated_at ?? ''

      };
    }


    return null;
  }

  private stopRecord(): void {

    let record: any = this.getRunningTimeTrackingRecord;

    let item: any = {
      ...record,
      stop: this.stop,
      text: this.text,
      ticket_url: this.ticket_url,
      task: {
        ...record.task,
        finished: this.finishTask

      },
    }

    this.setTimeTrackingRecordIdChannel();

    this.stopRunningRecord({
      id: this.runningTimeTrackingRecord.id,
      resource: RESOURCE_TIME_TRACKING_RECORD,
      data: item
    });

  }

  private setTimeTrackingRecordIdChannel() {

    let id: number = this.authService.getUserId();

    this.$echo.private(`TimeTrackingRecord.${id}`)
        .listen('TimeTracking\\UserHasStoppedNewRecord', (e) => {

          this.$emit('timetrackingrecord-stopped', e);
          this.setRunningRecord(null);
//          this.updateListItem(e.timeTracking);
          this.loadDataList({resource: RESOURCE_TIME_TRACKING_RECORD});

        });

  }

  private time(): any {

    this.stop = this.$moment().format(this.appConfig.DATETIME_FORMAT_SQL);

  }

  private setStopTime(mode: number): void {

    switch (mode) {

        // set to now
      case 1:
        this.stop = this.getTimeNowString();
        break;
        // set to start time
      case 2:
        this.stop = this.runningTimeTrackingRecord.start;
        break;
        // add 15 minutes to currently set stop time
      case 3:
        this.stop = this.$moment(this.stop).add(15, 'minutes').format(this.appConfig.DATETIME_FORMAT_SQL);
        break;

    }

  }

  private getTimeNowString(): string {

    return this.$moment().format(this.appConfig.DATETIME_FORMAT_SQL);

  }

  mounted() {

    this.time();
    this.setTimeTrackingRecordIdChannel();

  }


}
